import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";
import { Symbols } from "../GameComponents/Symbols";
import { FreespinsModel } from "../GameComponents/Freespins/FreespinsModel";
import { DataManager } from "../Managers/DataManager";

@engineComponent(ComponentTypes.DisplayObject)
export class Reel2 extends Reel {
    //******************************************************************************************************************
    //  VARIABLES (INITIALIZE)
    //******************************************************************************************************************

    protected inFreeSpins: boolean;

    //******************************************************************************************************************
    //  INITIALIZE
    //******************************************************************************************************************

    public initialize(
        previousReel: Reel,
        nextReel: Reel,
        index: number,
        symbols: Symbols,
        strip: Array<number>,
        positionX: number,
        positionY: number,
        symbolCount: number,
        symbolTopCount: number,
        symbolBottomCount: number,
        symbolWidth: number,
        symbolHeight: number,
        startDelay: number,
        stopDelay: number,
        inFreeSpins?: boolean,
    ): void {
        super.initialize(
            previousReel,
            nextReel,
            index,
            symbols,
            strip,
            positionX,
            positionY,
            symbolCount,
            symbolTopCount,
            symbolBottomCount,
            symbolWidth,
            symbolHeight,
            startDelay,
            stopDelay,
        );

        this.inFreeSpins = inFreeSpins;
    }

    //******************************************************************************************************************
    //  SHOW SYMBOLS
    //******************************************************************************************************************

    public showSymbols(): void {
        super.showSymbols();
    }

    //******************************************************************************************************************
    //  SPIN TEASE
    //******************************************************************************************************************

    public spinFakeTease(): void {
        this.isTeasing = true;
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected getSymbol(symbolId: number, symbolCase: string): Symbol {
        if (symbolCase === Symbol.CaseRotation) {
            symbolCase = Symbol.CaseNormal;
        }

        const symbol = super.getSymbol(symbolId, symbolCase);

        if (
            this.isTeasing &&
            symbol.getCurrentCase() === Symbol.CaseBlur &&
            this.teasingSymbols.indexOf(symbol.id + 1) === -1
        ) {
            symbol.alpha = 0.4;
        }

        return symbol;
    }

    protected returnSymbol(symbol: Symbol): void {
        symbol.alpha = 1;

        super.returnSymbol(symbol);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Reel2.ts
 **/